
export default class MasterPage {
}